import { SecureRNG } from "./SecureRNG";
/**
 * RandomUtil.ts
 *
 * A wrapper for Math.random()
 */
export class RandomUtil {
    /**
     * @returns A floating-point, pseudo-random number between 0 (inclusive) and 1 (exclusive).
     */
    static nextDouble() {
        return this.getRNG().nextDouble();
    }
    /**
     * @returns A pseudo-random integer between min (inclusive) and max (exclusive).
     */
    static nextInt(min, max) {
        return this.getRNG().nextInt(min, max);
    }
    /**
     * @param weighting - A number between 0 and 1 representing success rates.
     * @example
     * nextBoolean(0.75); // 3/4 of the time the expected outcome is `true`.
     */
    static nextBoolean(weighting) {
        return this.getRNG().nextBoolean(weighting);
    }
    /**
     * Randomizes the elements of `array` in-place.
     * @deprecated Use {@link ArrayUtil.shuffle}
     */
    static shuffle(array) {
        const rng = this.getRNG();
        const size = array.length;
        for (let i = 0; i < size; i++) {
            const j = rng.nextInt(i, size);
            const temp = array[j];
            array[j] = array[i];
            array[i] = temp;
        }
    }
    /**
     * Get or Create the SecureRNG singleton.
     */
    static getRNG() {
        if (!this.rng) {
            this.rng = new SecureRNG();
        }
        return this.rng;
    }
}
//# sourceMappingURL=RandomUtil.js.map